// Copied from sidebar.js
const SidebarPath = (() => ({
  pathDict: {
    dashboard: {
      team: '',
      me: '',
    },
    startsWith: {
      '/payer_accounts/ID': '/organizations/ID/integrations',
      '/integrations/ID': '/organizations/ID/integrations',
      '/invoices/ID': '/organizations/:d+/client_invoices',
      '/invoices/I/ID': '/organizations/:d+/client_invoices',
      '/organizations/ID/team_invoices': '/organizations/ID/client_invoices',
      '/team_payments/:d+': '/organizations/:d+/team_payments/past',
      '/teams/ID': '/organizations/ID/teams',
      '/timesheets/:d+': '/organizations/:d+/timesheets',
      '/organizations/ID/payer_accounts': '/organizations/ID/integrations',
      '/organizations/ID/plans': '/organizations/ID/settings/billing',
      '/organizations/ID/billing': '/organizations/ID/settings/billing',
      '/organizations/ID/settings/invoices': '/organizations/ID/settings/billing',
      '/projects/:d+': '/organizations/:d+/projects',
      '/projects/:d+/teams': '/organizations/:d+/projects',
    },
    organizations: {
      team_invoices: '/client_invoices',
      'team_payments/bonus': '/team_payments',
      'team_payments/timesheets': '/team_payments',
      'time_entries/calendar': '/time_entries',
      'time_entries/daily': '/time_entries',
      'time_entries/weekly': '/time_entries',
      invites: '/members',
      merge_members: '/members',
      addons: '/settings',
      'adjustments/legacy': '/member_payment_accounts',
    },
    settings: { // activity
      'integrations/new': '/settings/activity',
      'settings/achievements': '/settings/activity',
      'settings/achievements/efficiency_pro': '/settings/activity',
      'settings/achievements/productivity_champ': '/settings/activity',
      'settings/achievements/time_hero': '/settings/activity',
      'settings/activity/client_screenshot_blur': '/settings/activity',
      'settings/activity/client_screenshot_frequency': '/settings/activity',
      'settings/activity/delete_screens_allowed': '/settings/activity',
      'settings/calendar': '/settings/activity',
      'settings/calendar/attendance_schedule_email_alerts': '/settings/activity',
      'settings/calendar/calendar_type': '/settings/activity',
      'settings/calendar/late_shift_grace_period': '/settings/activity',
      'settings/holidays': '/settings/activity',
      'settings/insights': '/settings/activity',
      'settings/invoices': '/settings/activity',
      'settings/job_sites': '/settings/activity',
      'settings/job_sites/job_site_notifications': '/settings/activity',
      'settings/job_sites/restrict_track_to_sites': '/settings/activity',
      'settings/map': '/settings/activity',
      'settings/map/location_tracking': '/settings/activity',
      'settings/overtime': '/settings/activity',
      'settings/payments': '/settings/activity',
      'settings/time_off': '/settings/activity',
      'settings/time_off_balances': '/settings/activity',
      'settings/work_breaks': '/settings/activity',
      'time_off_policies/archived': '/settings/activity',
      work_break_policies: '/settings/activity',
      'work_break_policies/notifications': '/settings/activity',
      // enterprise
      enterprise: '/settings/enterprise',
      'enterprise/device_provisioning': '/settings/enterprise',
      // organization
      'settings/2fa': '/settings/organization',
      'settings/email_notifications': '/settings/organization',
      'settings/members': '/settings/organization',
      'settings/product_links': '/settings/organization',
      'settings/projects': '/settings/organization',
      'settings/quickbooks': '/settings/organization',
      'settings/smart_notifications': '/settings/organization',
      'settings/sso': '/settings/organization',
      'settings/timer_apps': '/settings/timer_apps',
      'settings/activity': '/settings/timer_apps',
      'settings/screenshots': '/settings/timer_apps',
      'settings/timesheets': '/settings/timer_apps',
      'settings/activity/hide_individual_tools': '/settings/timer_apps',
      'settings/activity/collect_network_data': '/settings/timer_apps',
      'settings/activity/monitor_user_activity': '/settings/timer_apps',
      'settings/activity/client_app_and_url_tracking': '/settings/timer_apps',
      'settings/timesheets/reason_field_required': '/settings/timer_apps',
      'settings/timesheets/modify_time_allowed': '/settings/timer_apps',
    },
  },
  stripNumericId(path) {
    // "/digits" + (/ or $)" replace globally with "/ID" + ("/" or eol)
    return path.replace(/\/\d+($|\/)/g, '/ID$1');
  },
  normalizePath: function (_path, section) {
    var that = this;
    // ['', 'organizations', '1', 'team_payments', 'bonus']
    var splitPath = _path.split('/');
    // '1'
    var orgId = splitPath[2];
    // normal matching
    // 'team_payments/bonus'
    // 'team_payments/ID'
    var longKey = this.stripNumericId(splitPath.slice(3).join('/'));
    // settings with 3+ path segments
    var shortKey = this.stripNumericId(splitPath.slice(3, 5).join('/'));
    // 'team_payments/bonus' -> '/team_payments'
    // 'team_payments/:d+' -> '/team_payments/past',
    // 'organizations/1/settings/projects/preselect_user_role' -> 'settings/organization'
    var consistentPath = that.pathDict[section][longKey] || that.pathDict[section][shortKey];

    if (consistentPath !== undefined) {
      // '/' + 'organization' + '/' + '1' + '/team_payments'
      // '/organizations/ID/team_payments'
      //organizations/ID/settings/activity
      _path = '/' + splitPath[1] + '/' + 'ID' + consistentPath;
    }
    return _path;
  },
  // Sample usage: /users/:slug, /users/:d+/edit, /users/:slug/edit
  matchesPath: function (pattern, path) {
    const regexPattern = pattern
      .replace(/:d\+/g, '\\d+')     // matches digits only
      .replace(/:slug/g, '[^/]+')   // matches any non-slash segment
      .replace(/\//g, '\\/');       // escape slashes

    const regex = new RegExp(`^${regexPattern}$`);
    return regex.test(path);
  },
}))();

export const SIDEBAR_COLLAPSED = 'sidebar_collapsed';
export const SIDEBAR_MENU_ITEMS_VISIBLE = 'sidebar_menu_items_visible';
export const SIDEBAR_TABLET_EXPANDED = 'sidebar_tablet_expanded';
export default SidebarPath;
